import React, { useState, useRef } from 'react'
import { OverlayTrigger, Popover, Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { useTransactionLists } from 'api/hooks/use-transaction-lists'

const TransactionListFilter = ({ params, setParams }) => {
  const { isSuccess, data: allLists = [] } = useTransactionLists({
    options: { refetchOnWindowFocus: false }
  })

  const sectionId = params.section_id
  const lists = sectionId
    ? allLists.filter((list) => list.section_id === sectionId)
    : allLists

  const [showPopover, setShowPopover] = useState(false)
  const [pendingValue, setPendingValue] = useState(params.transactionListId || '')
  const target = useRef(null)

  const isActive = !!(params.transactionListId && params.transactionListId !== '')

  const applyFilter = (updater) => {
    setParams(updater)
  }

  const handleToggle = (nextShow) => {
    if (!nextShow && pendingValue !== (params.transactionListId || '')) {
      // commit the pending selection when the user clicks outside the popover
      applyFilter((prev) => ({ ...prev, transactionListId: pendingValue, page: 1 }))
    }
    setShowPopover(nextShow)
  }

  const handleApply = () => {
    applyFilter((prev) => ({ ...prev, transactionListId: pendingValue, page: 1 }))
    setShowPopover(false)
  }

  const handleClear = () => {
    setPendingValue('')
    applyFilter((prev) => ({ ...prev, transactionListId: '', page: 1 }))
    setShowPopover(false)
  }

  const popover = (
    <Popover id="popover-transaction-list-filter" className="filterable-header-popover">
      <Popover.Body>
        <div className="mb-3">
          <strong>List</strong>
        </div>
        <div className="mb-3">
          <Form.Select
            value={pendingValue}
            size="sm"
            onChange={(e) => setPendingValue(e.target.value)}
          >
            <option value="">Select list</option>
            {isSuccess &&
              Object.entries(
                lists.reduce((groups, list) => {
                  const name = list.section?.name || 'Other'
                  if (!groups[name]) groups[name] = []
                  groups[name].push(list)
                  return groups
                }, {})
              ).map(([sectionName, sectionLists]) => (
                <optgroup key={sectionName} label={sectionName}>
                  {sectionLists.map((list) => (
                    <option key={`list-option-${list.id}`} value={list.id}>
                      {list.name}
                    </option>
                  ))}
                </optgroup>
              ))}
          </Form.Select>
        </div>
        <div className="text-muted small mb-3">
          This filter will not be saved and will reset on page change.
        </div>
        <div className="d-flex justify-content-between gap-2">
          <Button variant="light" size="sm" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="primary" size="sm" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      List
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        overlay={popover}
        show={showPopover}
        onToggle={handleToggle}
        rootClose
      >
        <Button
          ref={target}
          variant={isActive ? 'primary' : 'light'}
          size="sm"
          className="ms-1 border-0"
          style={{ padding: '2px 6px', minWidth: 'auto' }}
          onClick={(e) => {
            e.stopPropagation()
            handleToggle(!showPopover)
          }}
        >
          <FontAwesomeIcon icon={faFilter} size="xs" />
        </Button>
      </OverlayTrigger>
    </span>
  )
}

export default TransactionListFilter
